import { localStore, selectorActions } from '../../services';

function getPinnedItemsFromStore() {
  return localStore.get( 'pinnedItems' ) || [];
}

function saveStoreChanges( state ) {
  let items = [];
  // the reason for this complication is the fact that it has to be compatible
  // so that people can still test it if they were on the website once before
  for ( let selector in state ) {
    for ( let filter in state[selector] ) {
      for ( let item in state[selector][filter] ) {
        items.push( `${selector}#${filter}#${item}` );
      }
    }
  }
  localStore.set( 'pinnedItems', items );
}

export const pinnedItemsReducer = ( state = {}, action ) => {
  let newState = {};
  switch ( action.type ) {
    case selectorActions.INIT:
      return getPinnedItemsFromStore().reduce( ( current, item ) => {
        let items = item.split( '#' );
        let target = current;
        for ( let key of items ) {
          if ( !target[key] ) {
            target[key] = {};
          }
          target = target[key];
        }
        target = true;
        return current;
      }, {} );
    case selectorActions.PINITEM:
      newState = {...state};
      if ( !newState[action.group] ) {
        newState[action.group] = {};
      }
      if ( !newState[action.group][action.variable] ) {
        newState[action.group][action.variable] = {};
      }
      if ( !newState[action.group][action.variable][action.value] ) {
        newState[action.group][action.variable][action.value] = true;
      }
      saveStoreChanges( newState );
      return newState;
    case selectorActions.UNPINITEM:
      newState = {...state};
      delete newState[action.group][action.variable][action.value];
      saveStoreChanges( newState );
      return newState;
    case selectorActions.REMOVEPINNEDITEMS:
      newState = {...state};
      delete newState[action.group];
      saveStoreChanges( newState );
      return newState;
    case selectorActions.REMOVEPINNEDFILTER:
      newState = {...state};
      delete newState[action.group][action.variable];
      saveStoreChanges( newState );
      return newState;
    default:
      return state;
  }
};